// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ZCZG","title":"Header_title__2RoW2","left":"Header_left__36zd5","clinicName":"Header_clinicName__290L_"};